import { LANG } from './types';

export const setLang = (lang) => {
    return {
        type: LANG.SET_LANG,
        lang: lang,
    }
}